import React, { useMemo } from 'react';

import Footer from './Footer';
import NotImplemented from '../NotImplemented';
import safelyStringifyJSON from '../../utils/safelyStringifyJSON';
import {
  ACURA_SITE_NAME,
  ENGINE_SITE_NAME,
  HONDA_SITE_NAME,
  MARINE_SITE_NAME,
  PSP_SITE_NAME,
  PE_SITE_NAME,
} from '../../utils/constants';
import { createObjectFromProps } from '../../utils/object';
import { useAppName } from '../../utils/sitecoreContext';
import { variant1, variant2, variant3, variant4, variant5 } from './service/constants';

const FooterMap = ({ variant: propVariant, fields, rendering }) => {
  const appName = useAppName();
  let variant;
  let mappedFields = fields;

  switch (appName) {
    case ENGINE_SITE_NAME:
      variant = variant1;
      break;

    case MARINE_SITE_NAME:
      variant = variant2;
      break;

    case PSP_SITE_NAME:
      variant = variant3;
      break;

    case ACURA_SITE_NAME:
      variant = variant4;
      break;

    case HONDA_SITE_NAME:
    case PE_SITE_NAME:
      variant = variant5;
      break;

    default:
      mappedFields = null;
      break;
  }

  const appNameConfig = useMemo(() => ({ variant: propVariant ?? variant }), [propVariant, variant]);

  mappedFields = useMemo(() => createObjectFromProps(mappedFields), [safelyStringifyJSON(mappedFields)]);

  if (mappedFields === null) {
    return <NotImplemented name="Footer" />;
  }

  return <Footer appNameConfig={appNameConfig} componentName={rendering?.componentName} fields={mappedFields} />;
};

export default FooterMap;
